import { Image } from '@chakra-ui/react';
import { invariant } from '@ifixit/helpers';
import { LocaleCode } from '@ifixit/i18n';
import { useShopifyStorefrontClient } from '@ifixit/shopify-storefront-client';
import { CartDrawer } from '@ifixit/ui-chakra';
import type { ElementType } from 'react';
import { SupportLink } from 'Shared/support-link';

type CartDrawerWrapperProps = {
   locale: LocaleCode | null;
   storeCode: string;
   linkComponent?: ElementType;
};

export function CartDrawerWrapper({ locale, storeCode, linkComponent }: CartDrawerWrapperProps) {
   const { cartUrl } = useShopifyStorefrontClient();
   invariant(cartUrl, 'cart url must be provided for carpenter cart drawer');
   invariant(locale, 'locale must be provided for carpenter cart drawer');

   return (
      <CartDrawer
         localeCode={locale}
         ImageComponent={CartImage}
         supportLinkComponent={SupportLink}
         viewCartUrl={cartUrl}
         storeCode={storeCode}
         linkComponent={linkComponent}
         recordMerchExperiment={() => true}
      />
   );
}

function CartImage({ alt, src }: { alt?: string; src: string }) {
   const srcUrl = new URL(src);
   const params = new URLSearchParams(srcUrl.search);
   params.set('width', '70');
   const newSrc = `${srcUrl.origin}${srcUrl.pathname}?${params.toString()}`;
   return <Image src={newSrc} alt={alt} objectFit="cover" />;
}
